export default "__VITE_ASSET__DQm0efge__"